import { TenantType } from '@xeetr/types/enums'
import { ManagementTenant } from '@xeetr/types/models'
import { addMinutes } from 'date-fns'

export const getMinutesFromTime = (time?: string) => {
  if (!time) return 90
  const [hours, minutes] = time.split(':')
  return parseInt(hours) * 60 + parseInt(minutes)
}

export const calculateTimeEnd = (start: Date, tenant: ManagementTenant) => {
  switch (tenant.type) {
    case TenantType.FOOD:
      return addMinutes(
        start,
        tenant?.useLengthOfStay ? getMinutesFromTime(tenant?.defaultLengthOfStay) : 90
      )
    case TenantType.SERVICE:
    default:
      return addMinutes(start, 60)
  }
}
